import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { ISMT_DotTaoDe } from "../../../model/respone/de-thi/ISMT_DotTaoDe";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { ISMT_DotTaoDe_Vm } from "../../../model/respone/de-thi/ISMT_DotTaoDe_Vm";

export const eDotTaoDeActionsObj = {
  LOAD_START: {} as any,
  LOAD_SUCCESS: {} as ISMT_DotTaoDe_Vm[],
  LOAD_ERRR: "",

  SAVE_START: {} as ISMT_DotTaoDe,
  SAVE_SUCCESS: {} as ISMT_DotTaoDe,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  DELETE_MULTIPLE_START: {} as number[],
  DELETE_MULTIPLE_SUCCESS: undefined,
  DELETE_MULTIPLE_ERROR: "",

  SELECTED_ID: [] as number[],

  SHOW_EDIT_MODAL: {} as undefined | ISMT_DotTaoDe,
  CLOSE_EDIT_MODAL: undefined,

  CHANGE_REQUEST: {} as any,
  CLOSE_PROCESSING_MODAL: undefined,

  CREATE_DETHI_START: {} as IProcessRequest<number>,
  CREATE_DETHI_SUCCESS: "",
  CREATE_DETHI_ERROR: "",
};
export const eDotTaoDeActionIds = generateActionTypeIds(
  eDotTaoDeActionsObj,
  "DOT_TAO_DE"
);
export type IDotTaoDeActionTypes = IGenericActionType<
  typeof eDotTaoDeActionsObj,
  "DOT_TAO_DE"
>;
